import p from "./ghl-ui.es1411.js";
import a from "./ghl-ui.es1412.js";
import i from "./ghl-ui.es1413.js";
import h from "./ghl-ui.es1414.js";
import s from "./ghl-ui.es1415.js";
function t(e) {
  var o = -1, l = e == null ? 0 : e.length;
  for (this.clear(); ++o < l; ) {
    var r = e[o];
    this.set(r[0], r[1]);
  }
}
t.prototype.clear = p;
t.prototype.delete = a;
t.prototype.get = i;
t.prototype.has = h;
t.prototype.set = s;
export {
  t as default
};
